module.exports = __webpack_public_path__ + "img/home-rbn-1.3658406a.png";